import { useState, useEffect } from "react";
import { LineChartExample } from "./overview/lineChart";
import { useAuth } from "../context/AuthContext";
import { OverviewCarousel } from "../services/api";
import { OverviewService } from "../services/api/overview.service";
import AppointmentsList from "./overview/UpcomingAppointments";
import RevenueChart from "./overview/RevenueChart";
import PerformanceTable from "./overview/PerformanceTable";
import { IndianRupee } from "lucide-react";

export function OverviewView() {
  const [isLoading, setIsLoading] = useState(true);
  const [overviewData, setOverviewData] = useState<OverviewCarousel | null>(
    null
  );

  const { user } = useAuth();

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await OverviewService.getOverviewCarousel();
        if (data) {
          setOverviewData(data);
        }
      } catch (error) {
        console.error("Error loading overview data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);
  return (
    <section>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Stats Cards */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium" style={{ color: "#A2A2A2" }}>
            Total Patients
          </h3>
          <p className="mt-2 text-3xl font-semibold">
            {" "}
            {overviewData?.data?.patientData?.totalPatientCount ?? "0"}
          </p>
          <p className="mt-2 text-sm" style={{ color: "#A2A2A2" }}>
          <span className="text-green-600">
            {(overviewData?.data.patientData.percentageIncrease ?? 0).toFixed(2)}%
          </span>{" "}
          from last month
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium" style={{ color: "#A2A2A2" }}>
            Todays Appointments
          </h3>
          <p
            className="mt-2 text-3xl font-semibold"
            style={{ color: "#1C1C1C" }}
          >
            {" "}
            {overviewData?.data?.appointmentData?.todaysAppointments ?? "0"}
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium" style={{ color: "#A2A2A2" }}>
            Appointments Cancelled
          </h3>
          <p className="mt-2 text-3xl font-semibold text-gray-900">
            {overviewData?.data?.cancelledAppointmentData
              ?.cancelledAppointmentsCount ?? "0"}
          </p>
          <div className="flex justify-between">
            <p className="mt-2 text-sm" style={{ color: "#A2A2A2" }}>
              <span className="px-1" style={{ color: "#F05746" }}>
                {" "}
                {/* {overviewData?.data?.cancelledAppointmentData?.roleCount
                  .patient ?? "0"}{" "} */}
                  {Math.floor(overviewData?.data.cancelledAppointmentData.byClinic ?? 0)}%
              </span>
              By Clinic
            </p>
            <p className="mt-2 text-sm" style={{ color: "#A2A2A2" }}>
              <span className="px-1" style={{ color: "#F05746" }}>
                {/* {overviewData?.data?.cancelledAppointmentData?.roleCount
                  .doctor ?? "0"}{" "} */}
                  {Math.floor(overviewData?.data.cancelledAppointmentData.byDoctor ?? 0)}%
              </span>
              By Doctor
            </p>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium" style={{ color: "#A2A2A2" }}>
            Revenue
          </h3>
          <p className="mt-2 text-3xl font-semibold text-gray-900 flex flex-row items-center">
           <IndianRupee className="w-4 h-4"/> {overviewData?.data?.revenueData?.totalRevenue ?? "0"}
          </p>
          <p className="mt-2 text-sm text-green-600">
            {overviewData?.data?.revenueData?.lastMonthRevenue ?? "0"}% from
            last month
          </p>
        </div>
      </div>
      <div
        className={`w-full grid gap-4 p-2 ${
          (user?.role?.toLowerCase() === "clinic" || user?.role?.toLowerCase() === "medicalcamp")
            ? "grid-cols-1"
            : "grid-cols-1 lg:grid-cols-2"
        }`}
      >
        <LineChartExample />
        {user?.role?.toLowerCase() === "admin" && <RevenueChart />}
      </div>

      <div>
        {(user?.role?.toLowerCase() === "clinic" || user?.role?.toLowerCase() === "medicalcamp") && <AppointmentsList />}
        {user?.role?.toLowerCase() === "admin" && <PerformanceTable />}
      </div>
    </section>
  );
}
